import React, { useContext, useEffect, useState } from "react"
import { styled } from "@mui/material/styles";
import Step1 from "./step1"
import { Box, CircularProgressProps, useTheme } from "@mui/material";
import Step2 from "./step2";
import BottomStepper from "./BottomStepper";
import TopStepper from "./TopStepper";
import Step3 from "./step3";
import { onboardingPlansService } from "../../../services/onboardingPlans";
import Step4 from "./step4";
import Step5 from "./step5";
import Step6 from "./step6";
import Step7 from "./step7";
import ConfettiTNT from "../../insightsV2/common/confetti";
import LoaderAnimation, { LoaderAnimationV2 } from "../../../assets/images/icon/LoaderAnimation";
import CommonTypo from "../../../components/CommonTypo";
import RightPartRegistration from "../rightPartRegistration";
import { trackingService } from "../../../services/tracking";
import { Link, useNavigate } from "react-router-dom";
import queryParams from "../../../utils/getQueryParams";
import { userService } from "../../../services/auth";
import { UserTypeContext } from "../../../context/userStatus";

const imagePathsByStep = {
    1: "/onboardingStep1.svg",
    2: "/onboardingStep2.svg",
    3: "/onboardingStep3.svg",
    4: "/onboardingStep4.svg",
    5: "/onboardingStep5.svg",
    6: "/onboardingStep5.svg",
    7: "/onboardingStep7.svg",
    8: "/onboardingStep7.svg",
    9: "/onboardingStep10.svg",
};
const uniqueImagePaths = [...new Set(Object.values(imagePathsByStep))];

const RootStyle = styled("div")(({ theme }) => ({
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    gap: "22px",
    padding: "0 100px",
    [theme.breakpoints.up("xl")]: {
        padding: "60px",
    },
    [theme.breakpoints.down("lg")]: {
        padding: "40px",
    },
    [theme.breakpoints.down("md")]: {
        padding: "30px",
    },
    [theme.breakpoints.down("sm")]: {
        padding: "20px",
    },
}));
const OnBoardingWithSteps = ({ setVisible = (x: boolean) => { } }) => {
    const navigate = useNavigate()
    const queryData = queryParams()
    const [currentStep, setCurrentStep] = useState(1)
    const [userIdentificationStatus, setUserIdentificationStatus] = useState("")
    const [listOfImprovements, setListOfImprovements] = useState([]);
    const [secondselectedPlans, setSecondSelectedPlans] = useState([])
    const [selectedPlans, setSelectedPlans] = useState([])
    const [planSelectedOutcomes, setSelectedPlanOutcomes] = useState([])
    const [planSelectedInfluences, setSelectedPlanInfluences] = useState([])
    const [planSelectedReflectives, setSelectedPlanReflectives] = useState([])
    const [planOutcomes, setPlanOutcomes] = useState([])
    const [planInfluences, setPlanInfluences] = useState([])
    const [planReflectives, setPlanReflectives] = useState([])
    const [userIdLocal, setUserIdLocal] = useState(localStorage.getItem("anonymous-user-id"))
    const [levelTracked, setLevelTracked] = useState(false)
    const [planTracked, setPlanTracked] = useState(false)
    const [outcomeTracked, setOutcomeTracked] = useState(false)
    const [influenceTracked, setInfluenceOfData] = useState(false)
    const [reflectiveTracked, setReflectiveTracked] = useState(false)
    const [progress, setProgress] = useState(0)
    const { state: IUserTypeState } =
        useContext(UserTypeContext);
    const isDarkMode = useTheme().palette.mode === "dark" || IUserTypeState.isDarkMode
    useEffect(() => {
        uniqueImagePaths.forEach((path) => {
            if (path) {
                const img = new Image();
                img.src = path;
            }
        });
        getAnynymousId()
    }, []);

    const getAnynymousId = () => {
        if (localStorage.getItem("anonymous-user-id")) {
            setUserIdLocal(localStorage.getItem("anonymous-user-id"))
        } else {
            userService.getAnonymous().then(({ response }) => {
                console.log("data", response.uid);
                setUserIdLocal(response.uid)
                localStorage.setItem("anonymous-user-id", response.uid)
            }).catch(err => {
                console.log("err", err);
            })
        }
    }

    const trackAnonymousEvents = (eventName, extraObj = {}) => {
        userService.trackAnonymousEvent({
            "mixpanel_type": eventName,
            ...extraObj,
            "uid": userIdLocal
        }).then(({ response }) => {
            console.log("data", response.uid);
            localStorage.setItem("anonymous-user-id", response.uid)
        }).catch(err => {
            console.log("err", err);
        })
    }

    const setNextStep = () => {
        const nextStep = currentStep + 1
        console.log("nextStep", nextStep);
        if (nextStep === 3 && !levelTracked) {
            setLevelTracked(true)
            trackAnonymousEvents(userIdentificationStatus === "no" ? "LEVEL_LOW" : "LEVEL_HIGH")
        }
        if (nextStep === 5 && !planTracked) {
            setPlanTracked(true)
            trackAnonymousEvents("SIGN_UP_PLAN_C", {
                plan_name: secondselectedPlans.map(it => it.name)[0]
            })
        }
        if (nextStep === 6 && !outcomeTracked) {
            setOutcomeTracked(true)
            trackAnonymousEvents("SIGN_UP_OUTCOMES_C")
        }
        if (nextStep === 7 && !influenceTracked) {
            setInfluenceOfData(true)
            trackAnonymousEvents("SIGN_UP_INFLUENCES_C")
        }
        if (nextStep === 8 && !reflectiveTracked) {
            setReflectiveTracked(true)
            trackAnonymousEvents("SIGN_UP_REFLECTIVE_C")
        }
        setCurrentStep(nextStep)
        if (nextStep === 8) {
            setVisible(true)
            setTimeout(() => {
                setCurrentStep(9)
                setVisible(false)
                // setProgressPer()
            }, 3000);
        }
    }
    const setProgressPer = () => {
        setTimeout(() => {
            setProgress(prev => {
                if (prev < 100) {
                    setProgressPer(); // continue recursion
                    return prev + 2;
                } else {
                    setCurrentStep(10)
                }
                return prev;
            });
        }, 500);
    };
    const setPreviousStep = () => {
        setCurrentStep(currentStep - 1)
    }
    useEffect(() => {
        getPlans()
    }, [])
    useEffect(() => {
        if (currentStep === 5 && secondselectedPlans[0]) {
            getPlanInfo()
        }
    }, [currentStep, secondselectedPlans])
    const submitPlan = (userDetails) => {
        console.log("userDetails", userDetails);
        const userId = {
            uid: userDetails?.data?.uid,
        };
        const updatedUserValues = {
            ...userId,
            level: userIdentificationStatus === 'yes' ? "HIGH" : "LOW",
        };

        userService
            .updateUserLevel(updatedUserValues)
            .then((data) => {
                // trackingService.signupCompletedBoarding(outcomeState.token, {
                //   mixpanel_type: "NOTIFICATION_ONBOARDING"
                // });
                trackingService.signupCompletedBoarding(userDetails?.['x-access_token'], {
                    mixpanel_type: "SIGNUP_COMPLETED"
                });
                // setLoadingOfData(true)
                // userService.reminderCreate({
                //   // ...values,
                //   "time": moment(`${selectedScheduleTime.hour}:${selectedScheduleTime.minutes}`, 'HH:mm').format(),
                //   "status": "ACTIVE",
                //   desktopReminderStatus: desktopEnabled ? "ACTIVE" : "NOT_ACTIVE",
                //   mobileReminderStatus: "ACTIVE",
                //   uid: userId.uid
                // }, outcomeState.token).then((data) => {
                onboardingPlansService
                    .setSelectedPlan({
                        "categoryIds": secondselectedPlans.map(it => it.categoryId),
                        "selectedOutcomeIds": planSelectedOutcomes.map(it => it.outcomeId),
                        "selectedReflectiveIds": planSelectedReflectives.map(it => it.reflectiveId),
                        "selectedInfluenceIds": planSelectedInfluences.map(it => it.influenceId),
                    }, userDetails?.['x-access_token']).then(() => {
                        localStorage.setItem("showAnimation", "true")
                        // setButtonLoader(false)
                        navigate("/tracking/confirmation" + queryData.qeryString);
                        // navigate("/tracking", { replace: true });
                    })
                // })
            }).catch(err => {

            })

    }
    const getPlanInfo = () => {
        onboardingPlansService
            .getPlanById({
                "categoryId": secondselectedPlans.map(it => it.categoryId)[0]
            }).then((data) => {
                setPlanOutcomes(data?.data[0]?.outcomes)
                setPlanInfluences(data?.data[0]?.influences)
                setPlanReflectives(data?.data[0]?.reflectives)
            })
    }
    const getPlans = () => {
        onboardingPlansService
            .getPlansList(/* tempToken */)
            .then((data: any) => {
                setListOfImprovements(data.data)
            })
            .catch((error) => {

            });
    }
    const imageRender = (path) => {
        return <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}>
            <img src={path} style={{
                width: "218px",
                height: "218px",
            }} alt="login"></img>
        </div>
    }
    const renderImage = () => {
        switch (currentStep) {
            case 1:
                return imageRender("/onboardingStep1.svg")
            case 2:
                return imageRender("/onboardingStep2.svg")
            case 3:
                return imageRender("/onboardingStep3.svg")
            case 4:
                return imageRender("/onboardingStep4.svg")
            case 5:
            case 6:
                return imageRender("/onboardingStep5.svg")
            case 7:
            case 8:
                return imageRender("/onboardingStep7.svg")
            // case 10:
            case 9:
                return imageRender("/onboardingStep10.svg")
            default:
                break;
        }
    }
    const renderSection = () => {
        switch (currentStep) {
            case 1:
                return <Box margin={"auto"} sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "22px",
                    width: "40%",
                    alignItems: "center",
                    textAlign: "center"
                }}>
                    {renderImage()}
                    <Step1 setNextStep={setNextStep} setPreviousStep={setPreviousStep} />
                    <CommonTypo size={16} fontWeight={400} color="var(--color-text-secondary)" lineHeight={22} extraSx={{
                        position: "fixed",
                        bottom: 40
                    }}>Already have an account? <Link to={"/login"} style={{
                        textDecoration: "none",
                        color: "#367DEF"
                    }}>
                            <span style={{
                                textDecoration: "none",
                                color: "#367DEF"
                            }}>Sign in</span>
                        </Link></CommonTypo>
                </Box>
            case 2:
                return <Box margin={"auto"} sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "22px",
                    width: "85%",
                    alignItems: "center",
                    textAlign: "center"
                }}>
                    <TopStepper progress={0} />
                    {renderImage()}
                    <Step2 setNextStep={setNextStep} setPreviousStep={setPreviousStep} setStatus={setUserIdentificationStatus} userIdentificationStatus={userIdentificationStatus} />
                    <BottomStepper
                        isOutcome={true}
                        isInfluence={false}
                        isRefQues={false}
                        isTracking={false}
                        handleClickStep={setNextStep}
                        handleClickPreStep={setPreviousStep}
                        curretStep={currentStep}
                        nextDisabled={!userIdentificationStatus || userIdentificationStatus === ""}
                        prevDisabled={false}
                        isMobile={false}
                        isDarkMode={isDarkMode}
                    />
                </Box>
            case 3:
                return <Box margin={"auto"} sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "32px",
                    width: "85%",
                    alignItems: "center",
                    textAlign: "center"
                }}>
                    <TopStepper progress={17} />
                    {renderImage()}
                    <Step3
                        setNextStep={setNextStep}
                        setPreviousStep={setPreviousStep}
                        setStatus={setUserIdentificationStatus}
                        listOfImprovements={listOfImprovements}
                        selectedPlans={selectedPlans}
                        setSelectedPlans={setSelectedPlans}
                        // tempToken={tempToken}
                        setListOfImprovements={setListOfImprovements}
                        isDarkMode={isDarkMode}
                    />
                    <BottomStepper
                        isOutcome={true}
                        isInfluence={false}
                        isRefQues={false}
                        isTracking={false}
                        handleClickStep={setNextStep}
                        curretStep={currentStep}
                        nextDisabled={selectedPlans.length <= 0}
                        handleClickPreStep={setPreviousStep}
                        prevDisabled={false}
                        isMobile={false}
                        isDarkMode={isDarkMode}
                    />
                </Box>
            case 4:
                return <Box margin={"auto"} sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "32px",
                    width: "85%",
                    alignItems: "center",
                    textAlign: "center"
                }}>
                    <TopStepper progress={34} />
                    {renderImage()}
                    <Step4
                        setNextStep={setNextStep}
                        setPreviousStep={setPreviousStep}
                        setStatus={setUserIdentificationStatus}
                        secondselectedPlans={secondselectedPlans}
                        selectedPlans={selectedPlans}
                        setSelectedPlans={setSelectedPlans}
                        isDarkMode={isDarkMode}
                        // tempToken={tempToken}
                        setSecondSelectedPlans={setSecondSelectedPlans}
                        setSelectedPlanOutcomes={setSelectedPlanOutcomes}
                        setSelectedPlanInfluences={setSelectedPlanInfluences}
                        setSelectedPlanReflectives={setSelectedPlanReflectives}
                    />
                    <BottomStepper
                        isOutcome={true}
                        isInfluence={false}
                        isRefQues={false}
                        isTracking={false}
                        handleClickStep={setNextStep}
                        handleClickPreStep={setPreviousStep}
                        curretStep={currentStep}
                        nextDisabled={secondselectedPlans.length <= 0}
                        prevDisabled={false}
                        isMobile={false}
                        isDarkMode={isDarkMode}
                    />
                </Box>
            case 5:
                return <Box margin={"auto"} sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "32px",
                    width: "60%",
                    alignItems: "center",
                    textAlign: "center"
                }}>
                    <TopStepper progress={51} />
                    {renderImage()}
                    <Step5
                        setNextStep={setNextStep}
                        setPreviousStep={setPreviousStep}
                        planOutcomes={planOutcomes}
                        setPlanOutcomes={setPlanOutcomes}
                        isDarkMode={isDarkMode}
                        planSelectedOutcomes={planSelectedOutcomes} setSelectedPlanOutcomes={setSelectedPlanOutcomes}
                    />
                    <BottomStepper
                        isOutcome={true}
                        isInfluence={false}
                        isRefQues={false}
                        isTracking={false}
                        handleClickStep={setNextStep}
                        handleClickPreStep={setPreviousStep}
                        curretStep={currentStep}
                        nextDisabled={planSelectedOutcomes.length <= 0}
                        prevDisabled={false}
                        isMobile={false}
                        isDarkMode={isDarkMode}
                    />
                </Box>
            case 6:
                return <Box margin={"auto"} sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "32px",
                    width: "60%",
                    alignItems: "center",
                    textAlign: "center"
                }}>
                    <TopStepper progress={68} />
                    {renderImage()}
                    <Step6
                        setNextStep={setNextStep}
                        setPreviousStep={setPreviousStep}
                        planInfluences={planInfluences}
                        setPlanInfluences={setPlanInfluences}
                        planSelectedInfluences={planSelectedInfluences} setSelectedPlanInfluences={setSelectedPlanInfluences}
                        isDarkMode={isDarkMode}
                    />
                    <BottomStepper
                        isOutcome={true}
                        isInfluence={false}
                        isRefQues={false}
                        isTracking={false}
                        handleClickStep={setNextStep}
                        handleClickPreStep={setPreviousStep}
                        curretStep={currentStep}
                        nextDisabled={planSelectedInfluences.length <= 0}
                        prevDisabled={false}
                        isMobile={false}
                        isDarkMode={isDarkMode}
                    />
                </Box>
            case 7:
                return <Box margin={"auto"} sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "32px",
                    width: "60%",
                    alignItems: "center",
                    textAlign: "center"
                }}>
                    <TopStepper progress={85} />
                    {renderImage()}
                    <Step7
                        setNextStep={setNextStep}
                        setPreviousStep={setPreviousStep}
                        planReflectives={planReflectives}
                        setPlanReflectives={setPlanReflectives}
                        planSelectedReflectives={planSelectedReflectives} setSelectedPlanReflectives={setSelectedPlanReflectives}
                        isDarkMode={isDarkMode}
                    />
                    <BottomStepper
                        isOutcome={true}
                        isInfluence={false}
                        isRefQues={false}
                        isTracking={false}
                        handleClickStep={setNextStep}
                        handleClickPreStep={setPreviousStep}
                        curretStep={currentStep}
                        nextDisabled={planSelectedReflectives.length <= 0}
                        prevDisabled={false}
                        isMobile={false}
                        isDarkMode={isDarkMode}
                    />
                </Box>
            case 8:
                return <Box sx={{
                }}>
                    <Box margin={"auto"} sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "32px",
                        width: "80%",
                        alignItems: "center",
                        textAlign: "center"
                    }}>
                        <TopStepper progress={100} />
                        {renderImage()}
                        <Step7
                            setNextStep={setNextStep}
                            setPreviousStep={setPreviousStep}
                            planReflectives={planReflectives}
                            setPlanReflectives={setPlanReflectives}
                            planSelectedReflectives={planSelectedReflectives} setSelectedPlanReflectives={setSelectedPlanReflectives}
                            isDarkMode={isDarkMode}
                        />
                        <BottomStepper
                            isOutcome={true}
                            isInfluence={false}
                            isRefQues={false}
                            isTracking={false}
                            handleClickStep={setNextStep}
                            handleClickPreStep={setPreviousStep}
                            curretStep={currentStep}
                            nextDisabled={planSelectedReflectives.length <= 0}
                            prevDisabled={false}
                            isMobile={false}
                            isDarkMode={isDarkMode}
                        />
                    </Box>
                </Box>
            case 9:
                // return <Box sx={{
                // }}>
                //     <Box margin={"auto"} sx={{
                //         display: "flex",
                //         flexDirection: "column",
                //         gap: "32px",
                //         width: "85%",
                //         alignItems: "center",
                //         textAlign: "center"
                //     }}>
                //         <TopStepper progress={100} />
                //         {renderImage()}
                //         <FacebookCircularProgress />
                //         <CommonTypo size={32} fontWeight={700} color="var(--color-text-primary)" lineHeight={36} extraSx={{
                //             whiteSpace: "nowrap"
                //         }}>Creating your plan </CommonTypo>
                //         <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)" lineHeight={20} extraSx={{
                //             whiteSpace: "nowrap"
                //         }}>{progress}% </CommonTypo>
                //     </Box>
                // </Box>
                return <Box sx={{
                }}>
                    <Box margin={"auto"} sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "32px",
                        width: "85%",
                        alignItems: "center",
                        textAlign: "center"
                    }}>
                        {renderImage()}
                        <RightPartRegistration newFlow registerCallback={submitPlan} anonymousID={userIdLocal} />
                    </Box>
                </Box>
            // case 10:

            default:
                break;
        }
    }
    return <RootStyle className={"login-right-part"}>
        {renderSection()}
    </RootStyle>
}

export default OnBoardingWithSteps

function FacebookCircularProgress(props: CircularProgressProps & {
    isMobile?: boolean
}) {
    return (
        <Box sx={{ position: 'relative', margin: props?.isMobile && "50px 0" }}>
            {/* props.isMobile ?  */<LoaderAnimationV2 color={"var(--color-new-main)"} /> /* : (
                <>
                    <CircularProgress
                        variant="determinate"
                        sx={{
                            color: " #11734A00"
                        }}
                        size={props.isMobile ? 200 : 140}
                        thickness={4}
                        {...props}
                        value={100}
                    />
                    <CircularProgress
                        variant="indeterminate"
                        disableShrink
                        sx={{
                            color: (theme) => palette.primary.main,
                            animationDuration: '550ms',
                            position: 'absolute',
                            left: 0,
                            [`& .${circularProgressClasses.circle}`]: {
                                strokeLinecap: 'round',
                            },
                        }}
                        size={props.isMobile ? 200 : 140}
                        thickness={4}
                        {...props}
                    />
                </>
            ) */}

        </Box>
    );
}